var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ee7d11",
    height: "50px",
    width: "50px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    stroke: "#ee7d11",
    strokeWidth: 0.992,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.192
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invoice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "invoice_1_",
    d: "M24,31.36c-4.059,0-7.36-3.302-7.36-7.36c0-0.214,0.009-0.428,0.028-0.64H5V22.64h11.768 c0.132-0.697,0.364-1.375,0.69-2.002c0.231-0.455,0.51-0.884,0.829-1.277H5V18.64h13.955c0.297-0.278,0.617-0.532,0.958-0.758 C21.122,17.07,22.536,16.64,24,16.64c4.059,0,7.36,3.301,7.36,7.36S28.059,31.36,24,31.36z M24,17.36 c-1.32,0-2.596,0.388-3.688,1.121c-0.938,0.62-1.703,1.479-2.214,2.485c-0.483,0.93-0.738,1.978-0.738,3.033 c0,3.661,2.979,6.64,6.64,6.64s6.64-2.979,6.64-6.64S27.661,17.36,24,17.36z M17,31.36H1c-0.199,0-0.36-0.161-0.36-0.36V1 c0-0.199,0.161-0.36,0.36-0.36h18c0.096,0,0.188,0.038,0.255,0.105l6,6C25.322,6.813,25.36,6.904,25.36,7v8H24.64V7.36H19 c-0.199,0-0.36-0.161-0.36-0.36V1.36H1.36v29.28H17V31.36z M19.36,6.64h4.771L19.36,1.869V6.64z M24.36,27.5H23.64v-1.14H22V25.64 h3c0.353,0,0.64-0.287,0.64-0.64s-0.287-0.64-0.64-0.64h-2c-0.75,0-1.36-0.61-1.36-1.36s0.61-1.36,1.36-1.36h0.64V20.5h0.721v1.14 H26v0.721h-3c-0.353,0-0.64,0.287-0.64,0.64s0.287,0.64,0.64,0.64h2c0.75,0,1.36,0.61,1.36,1.36s-0.61,1.36-1.36,1.36h-0.64V27.5z M14,27.36H5V26.64h9V27.36z M21,15.36H5v-0.72h16V15.36z M21,11.36H5v-0.72h16V11.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.787063b00f7fcb84e41c76b8fef3cfbd.svg";
export { ForwardRef as ReactComponent };